import truisms from './truisms.json';
import ICONS from './ICONS';

export default class TRUISMS {

    static exe() {
        window.WINAPI.MessageBox(
            "Truism",
            truisms[Math.floor(Math.random()*truisms.length)] + "\n\nJenny Holzer",
            {
                "Yes": () => { TRUISMS.exe() },
                "No": () => { TRUISMS.exe() }
            },
            ICONS.ASK
        );
    }
}


// WEBPACK FOOTER //
// ./src/walleris/TRUISMS.js